module.exports = __webpack_public_path__ + "img/visuels-campagne-summerdays-22-prolongations_slideshow.59af1d9f.png";